import React, { useEffect, useCallback } from 'react';

import { GoGameFiltersWithoutFavorites as Filters } from 'components/Filters';

import { Dialog, Grid, LegacyText } from '@gogame/components';
import { useMountedState, useProcessAsync } from '@gogame/hooks-ts';

import SummaryTable from 'scenes/MarketingPlanning/components/SummaryTable';

import PrimaryFilters from './Filters/PrimaryFilters';
import { useLoadSummaryByOwners } from './hooks';

const SummaryByOwnersDialog = ({
  year,
  month,
  version,
  filters,
  onClose,
  onExited,
  open,
}) => {
  const [loading, processAsync] = useProcessAsync();
  const [data, setData] = useMountedState(null);
  const [state, setState] = useMountedState({
    year,
    month,
    version,
    ...filters,
  });
  const loadSummaryByOwners = useLoadSummaryByOwners(processAsync);

  const loadData = useCallback(async () => {
    return loadSummaryByOwners(state).then(setData);
  }, [state]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleChangePrimaryFilters = (value) => {
    setState(value);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={false}
      loading={loading}
      onClose={onClose}
      onExited={onExited}
      open={open}
    >
      <Dialog.Title title={'Total Budgets Summary by Owners'} />
      <Filters
        controlled={true}
        initialDirty={true}
        initialValues={state}
        onChange={handleChangePrimaryFilters}
      >
        <PrimaryFilters />
      </Filters>
      <Dialog.Content padding={0} dividers={!data?.rows?.length}>
        <Grid container direction={'column'}>
          {data?.rows?.length ? (
            <SummaryTable data={data} rowsName={'Owners'} />
          ) : (
            <Grid
              container
              justifyContent={'center'}
              alignItems={'center'}
              style={{ padding: '24px' }}
            >
              <Grid item>
                <LegacyText>No results</LegacyText>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Dialog.Content>

      <Dialog.Actions>
        <Dialog.CloseButton />
      </Dialog.Actions>
    </Dialog>
  );
};

export default SummaryByOwnersDialog;
